/* Killer Golf Fit Quiz — SKU mapping (v4 / product-list-first)
 *
 * v4 (2026-05-20): Rewritten to follow the CURRENT Shopify catalog after CEO
 * restructure. Every cart line is a `fit-quiz-component`-tagged product variant.
 *
 *   Cart contents per build (8 lines, all $0, all tagged):
 *     1× system-configuration       (system = EQuilibrium / CenterStrike / Artifact)
 *     1× system kit                 (EQ kit / CS kit / artifact-putter)
 *     1× hand-orientation           (Right / Left)
 *     1× putter-color               (Black / Silver)
 *     1× shaft-length               (32" / 33" / 34" / 35")
 *     1× shaft-grip (Shaft Color)   (Shaft Black / Shaft Silver)
 *     1× grip-color                 (Grip Black / Grip Silver)
 *     1× grip (Grip Thickness)      (Thin / Medium / Thick)
 *
 *   Head shape (Wing / Blade) is NOT a cart line — neither `the-wing` nor
 *   `the-blade` carries the fit-quiz-component tag, and v4 sticks to tagged
 *   products only. Wing/Blade lives in line item properties + worker metadata
 *   for recommendation history. Cart total per build = $0.
 *
 * Variant IDs verified against admin GraphQL on 2026-05-20.
 */
(function () {
  window.KG_FIT_QUIZ_SKUS = {

    /* Head (Wing / Blade) — PARENT line of every build. Carries the build's price.
       NOT fit-quiz-component-tagged (the head products are revenue products, not
       option markers). variantId values verified against admin GraphQL 2026-05-20. */
    heads: {
      Wing:  { handle: 'the-wing',  variantId: 47279031910577, price: 525 },
      Blade: { handle: 'the-blade', variantId: 47279045673137, price: 495 }
    },

    /* Mirror of heads.X.price, used by Liquid catalog override + recommendation UI. */
    headPrices: { Wing: 525, Blade: 495 },

    /* System Configuration marker line. NOTE Shopify spelling 'Equillibrium' (double-L)
       while quiz UI uses 'EQuilibrium' (single-L) — variant title differs, key matches UI. */
    systemConfiguration: {
      handle: 'system-configuration',
      variants: {
        'EQuilibrium System':  47292700623025,
        'CenterStrike System': 47292700655793,
        'Artifact System':     47292700688561
      }
    },

    /* System kit line. Each system has 2–22 internal SKU variants; the quiz auto-picks
       `defaultVariant` for EQ/CS (no UI step yet) and the picked artifact for Artifact. */
    kits: {
      'EQuilibrium System':  {
        handle: 'equillibrium-65-kit-1',
        label: 'EQuilibrium Kit',
        defaultVariant: 'EQ 65',
        variants: { 'EQ 65': 47292746563761, 'Base 40': 47292746596529, 'Base 60': 47292746629297 }
      },
      'CenterStrike System': {
        handle: 'anchors-kits',
        label: 'CenterStrike Kit',
        defaultVariant: 'Anchors 25',
        variants: { 'Anchors 25': 47292752560305, 'Anchors 50': 47292752593073, 'Anchors 75': 47292752625841, 'Anchors 150': 47292752658609 }
      },
      'Artifact System': {
        handle: 'artifact-putter',
        label: 'Artifact',
        /* customer picks via state.artifact (label = variant title) */
        variants: {
          'Go Pro Mount':         47291211743409,
          'Bear':                 47291211808945,
          'Shot Glass':           47291211874481,
          'Vault':                47291211940017,
          'Cigarette Holder':     47291212005553,
          'Chapstick Holder':     47291212071089,
          'Wine Glass':           47291212136625,
          'King Crown':           47291212202161,
          'Trophy':               47291212267697,
          'Alignment Aid':        47291212333233,
          'Ball Marker Holder':   47291212398769,
          'Bottle Opener':        47291212464305,
          'Lego Base':            47291212529841,
          'Cigar Holder':         47291212595377,
          'Queen Crown':          47291212660913,
          'Speaker System':       47291212726449,
          'Laser Pointer System': 47291212791985,
          '"WTF" Emoji':          47291212857521,
          '"Angry" Emoji':        47291212923057,
          '"Laughing" Emoji':     47291212988593,
          '"Hmmm" Emoji':         47291213054129,
          '"Smiley" Emoji':       47291213119665
        }
      }
    },

    /* Ordered list with images for the Step-3 Artifact grid UI. Image URLs are the
       static CDN assets from the previous build; they survive product re-orgs. */
    artifactThemes: [
      { label: 'Bear',                 variantId: 47291211808945, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/80_626ca24f-d463-4bc5-8767-a014fccfb416.png?v=1778460384' },
      { label: 'Vault',                variantId: 47291211940017, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/7_e53229e2-4767-40b7-aa82-f4d696428b38.png?v=1778460384' },
      { label: 'King Crown',           variantId: 47291212202161, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/20260324_093109_365f0ea4-f3a2-4e97-916e-a74fa8e21d8f.jpg?v=1778460382' },
      { label: 'Queen Crown',          variantId: 47291212660913, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/91_9804f216-6376-40b7-b502-bdb671695795.png?v=1778460384' },
      { label: 'Trophy',               variantId: 47291212267697, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/36_37b4eaa8-57c5-4c9d-926f-fd02fd7dde43.png?v=1778460384' },
      { label: 'Wine Glass',           variantId: 47291212136625, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/81_13abfb1d-2aac-4eac-a91a-ced448a95112.png?v=1778460384' },
      { label: 'Shot Glass',           variantId: 47291211874481, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/90_d08a5971-dcda-4143-9ee9-14619c844c0f.png?v=1778460384' },
      { label: 'Cigar Holder',         variantId: 47291212595377, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/76_3ca96111-0b5c-46df-8bd3-0856c21c6b4f.png?v=1778460384' },
      { label: 'Bottle Opener',        variantId: 47291212464305, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/4_9ffd3b6a-b330-4626-8715-fd11b696cf32.png?v=1778460384' },
      { label: 'Ball Marker Holder',   variantId: 47291212398769, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/20_695dbb14-afaa-4393-af41-f87945733e72.png?v=1778460383' },
      { label: 'Lego Base',            variantId: 47291212529841, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/12_ff77f992-0c41-48c4-8e48-0f1c0c05a5a2.png?v=1778460384' },
      { label: 'Speaker System',       variantId: 47291212726449, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/34_14053b19-84d1-41eb-bf5c-d73836b53bfd.png?v=1778460384' },
      { label: 'Go Pro Mount',         variantId: 47291211743409, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/74_f77be732-5247-406d-84e4-26c27fe8fba7.png?v=1777591112' },
      { label: 'Laser Pointer System', variantId: 47291212791985, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/62_33c77cd9-ae6d-4675-a65c-2a22c4b3595c.png?v=1778460384' },
      { label: 'Cigarette Holder',     variantId: 47291212005553, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/16_b66bc00e-cb34-460b-8257-e06b9c5d3571.png?v=1778460384' },
      { label: 'Chapstick Holder',     variantId: 47291212071089, imageUrl: '' },
      { label: 'Alignment Aid',        variantId: 47291212333233, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/63_17e835a7-4923-43ef-b03e-299f6302df67.png?v=1778460384' },
      { label: '"WTF" Emoji',          variantId: 47291212857521, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/31_d5f6d447-3865-4b49-8af1-6727f8f516b9.png?v=1778460384' },
      { label: '"Angry" Emoji',        variantId: 47291212923057, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/43_3d19caa9-09d0-4170-8b98-1b1f0c5694ae.png?v=1778460384' },
      { label: '"Laughing" Emoji',     variantId: 47291212988593, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/53_38356bf7-1b76-42cb-82fb-e4fbd6aa91ae.png?v=1778460384' },
      { label: '"Hmmm" Emoji',         variantId: 47291213054129, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/28_e15084a8-f7af-4e2b-a8d3-1513c5b78f73.png?v=1778460384' },
      { label: '"Smiley" Emoji',       variantId: 47291213119665, imageUrl: 'https://cdn.shopify.com/s/files/1/0690/8497/1185/files/22_fb16295e-fc88-485a-b83e-37d4bee4570e.png?v=1778460384' }
    ],

    /* Six common option products. Keys = quiz UI state values verbatim so a single
       `options[field].variants[state[field]]` lookup resolves to a variant id. */
    options: {
      handOrientation: {
        handle: 'hand-orientation', role: 'Hand Orientation',
        variants: { 'Right Hand': 47292734013617, 'Left Hand': 47292733980849 }
      },
      putterColor: {
        handle: 'putter-color', role: 'Putter Color',
        variants: { 'Black': 47292733358257, 'Silver': 47292733391025 }
      },
      shaftLength: {
        handle: 'shaft-length', role: 'Shaft Length',
        variants: { '32 in': 47268429791409, '33 in': 47268429856945, '34 in': 47268429922481, '35 in': 47268429988017 }
      },
      shaftColor: {
        handle: 'shaft-grip', role: 'Shaft Color',
        /* UI data-value 'Silver' maps to product variant 'Shaft Silver' (variant id matched directly). */
        variants: { 'Black': 47268425564337, 'Silver': 47268425597105 }
      },
      gripColor: {
        handle: 'grip-color', role: 'Grip Color',
        /* UI data-value 'Black' / 'Silver' maps to product variant 'Grip Black' / 'Grip Silver'. */
        variants: { 'Black': 47268431069361, 'Silver': 47268431102129 }
      },
      gripThickness: {
        handle: 'grip', role: 'Grip Thickness',
        /* UI data-value 'Thin' / 'Medium' / 'Thick' maps 1:1 to product variants. */
        variants: { 'Thin': 47268425826481, 'Medium': 47268425892017, 'Thick': 47268425957553 }
      }
    },

    endpoints: {
      saveFitMetadata: 'https://putter-config-worker.accounts-ba5.workers.dev/save-putter'
    }
  };
})();
